import DEFAULT_CONFIG from './config.json';

let envConfig: Record<string, any> = {};
const defaultConfig: Record<string, any> = DEFAULT_CONFIG;

// Load environment-specific config if specified
const loadEnvConfig = async () => {
  if (import.meta.env.VITE_NODE_ENV) {
    const env = import.meta.env.VITE_NODE_ENV.trim();
    try {
      const module = await import(`./config.${env}.json`);
      envConfig = module.default;
    } catch (error) {
      console.warn(`Could not load config for environment: ${env}`, error);
    }
  }
};

// Load config on module initialization
loadEnvConfig();

const config = {
  get: (key: string) => {
    return envConfig[key] || defaultConfig[key];
  },
};

export default config;
